export const REACTIVATION_EMAIL_STORAGE_KEY = 'reactivation_email';

function normalizeEmail(email: string | null | undefined) {
  return typeof email === 'string' ? email.trim().toLowerCase() : '';
}

export function buildReactivationAuthUrl(currentSearch: string, phase?: 'otp') {
  const params = new URLSearchParams(currentSearch);
  params.set('step', 'reactivate');
  params.delete('email');

  if (phase === 'otp') {
    params.set('phase', 'otp');
  } else {
    params.delete('phase');
  }

  const query = params.toString();
  return query ? `/auth?${query}` : '/auth';
}

export function resolvePendingReactivationEmail(
  storedEmail: string | null | undefined,
  legacyQueryEmail: string | null | undefined
) {
  return normalizeEmail(storedEmail) || normalizeEmail(legacyQueryEmail);
}

export function persistReactivationEmail(
  setItem: (key: string, value: string) => unknown,
  email: string
) {
  const normalizedEmail = normalizeEmail(email);
  if (normalizedEmail) {
    setItem(REACTIVATION_EMAIL_STORAGE_KEY, normalizedEmail);
  }
  return normalizedEmail;
}

export function getStoredReactivationEmail(
  getItem: (key: string) => string | null
) {
  return normalizeEmail(getItem(REACTIVATION_EMAIL_STORAGE_KEY));
}

export function clearStoredReactivationEmail(
  removeItem: (key: string) => unknown
) {
  removeItem(REACTIVATION_EMAIL_STORAGE_KEY);
}
